import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { MedInputComponent } from "./med-input.component";
import { MedLabelModule } from "../med-label/med-label.module";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";

@NgModule({
  declarations: [
    MedInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedLabelModule,
    MedDirectiveSharedModule,
  ],
  exports: [
    MedInputComponent,
  ],
})
export class MedInputModule { }
